module.exports = __webpack_public_path__ + "static/media/soep.5e744c25.png";